export const defineConfirmed = (arr: any) => {
  const approvedRequests = arr?.filter((i: any) => i.status === 'fulfilled');
  return approvedRequests?.length > 0;
};
